export default __webpack_public_path__ + "static/good-guys-0efe61780507ac61bbaab5a3222e5d82.png";